module.exports = __webpack_public_path__ + "fonts/Gotham-Medium.18f5938c.eot";